<template>
	<div class='main-mybody' id='yitijiao'>
		<a-row>
			<a-col :span='6'><div>開戶方式  </div>
				<a-select v-model="params.khtype" placeholder="請選擇" style='width:8rem' @change="getdate">
					<a-select-option v-for="(item) in admintypeArr" :key="item.key+'100'" :value="item.value"
						style='width:10rem'>{{item.text}}</a-select-option>
				</a-select>
			</a-col>
			<a-col :span='6'><div>開始時間  </div>
				<a-date-picker v-model='params.begindate' placeholder='請選擇開始時間' :disabled-date="disabledDate"
					style='width: 8rem;' />
			</a-col>
			<a-col :span='6'><div>結束時間  </div>
				<a-date-picker v-model='params.enddate' placeholder='請選擇結束時間' :disabled-date="disabledDates"
					style='width: 8rem;' />
				<!-- <a-range-picker :placeholder="['開始時間','結束時間']" format="DD/MM/YYYY"
				v-model="params.timeDate" @change='fanhand'> -->
				</a-range-picker>
			</a-col>
			<a-col :span='1'></a-col>
			<a-col :span='5' >
				<div class='wrplf'>
					<a-button class="topBtn" style="background-color:#3bc7a1;" @click="getdate">
						<img src="@/image/icon_sousuo.png" class="btnIcon" />
						<span style="margin-left: .5rem;font-size: .7rem;"> 搜索</span>
					</a-button>
					<a-button class="topBtn" style="background-color:#ffa647;margin-left:auto;" @click="clearEvent">
						<img src="@/image/icon_chongzhi.png" class="btnIcon" />
						<span style="margin-left: .5rem;font-size: .7rem;"> 重置</span>
					</a-button>
				</div>
			</a-col>
			</a-row>		
			<a-row>
			<a-col :span='6' style='margin-top: -.5rem;'><div>開戶狀態  </div>
				<a-select v-model="params.khstatus" placeholder="請選擇" style='width:8rem' @change="getdate">
					<a-select-option v-for="(item) in khstatus" :key="item.key+'200'" :value="item.value"
						style='width:10rem'>{{item.text}}</a-select-option>
				</a-select>
			</a-col>
			<a-col :span='6'><div>國家地區  </div>
					<Situationall v-model="params.area" :url='$api.getParamList' ref='seachope'
						:params='{"type":"kharea"}' :style='"width:8rem"' :placeholder="'請選擇國家/地區'">
					</Situationall>
			</a-col>
			</a-row>
			<a-row>
			<a-col :span='24'>
				<div id='bottomMain'>
					<a-table id='ediotable' style="width:100%;" :columns="columns" :data-source="columnsData"
						:rowKey='(record, index) => index' :bordered="true" :pagination="false">
						<div slot='khtype' slot-scope="record" style="text-align: center">{{record.khtype}}</div>
						<div slot='khaduit' slot-scope="record" style="text-align: left;margin-left: 0%;">{{record.khaduit}}</div>
						<div slot='name' slot-scope="record"  style="margin-left: 10%;text-align: left;">{{record.name||'無記錄'}}</div>
						<div slot='area' slot-scope="record" style="margin-left: 10%;text-align: left;">{{record.area}}</div>
						<div slot='khid' slot-scope="record">
							<div class='fath_yiti'>
								<div v-if='record.khstatus == 1'><img src="@/image/iconadmin1.png" alt="" class='wimg'>
								</div>
								<div v-if='record.khstatus == 2'><img src="@/image/iconadmin.png" alt="" class='wimg'>
								</div>
								<div v-if='record.khstatus == 3'><img src="@/image/no.png" alt="" class='wimg'></div>
								<div>{{record.khid}}</div>
							</div>
						</div>
					</a-table>
					<div class="paginationView">
						<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
					</div>
					<!--:pagination="false" -->
				</div>
				<div class='look_tuijian' style="margin-bottom: .5rem;">
					<div v-if='params.khstatus==1||params.khstatus==""'>
						<img src="@/image/iconadmin1.png" alt="" class='wimg'>
						完成開戶 {{params.khfinishnum}}
					</div>
					<div v-if='params.khstatus==2||params.khstatus==""'>
						<img src="@/image/iconadmin.png" alt="" class='wimg'>
						開戶審批 {{params.khunfinishnum}}
					</div>
					<div v-if='params.khstatus==3||params.khstatus==""'>
						<img src="@/image/no.png" alt="" class='wimg'>
						取消開戶 {{params.khcancelnum}}
					</div>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['itemobj'],
		data() {
			return {
				tzPageNum: '',
				columns: [
					// { title: 'D', dataIndex: 'key' },
					{
						title: '開戶ID',
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots: {
							customRender: 'khid'
						}
					},
					{
						title: '國家/地區',
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots: {
							customRender: 'area'
						}
					},
					{
						title: '中/英文姓名',
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots: {
							customRender: 'name'
						}
					},
					// {
					// 	title: '英文姓名',
					// 	dataIndex: 'en_name',
					// 	align: 'center',
					// 	width: '14%'
					// },
					{
						title: '提交時間',
						dataIndex: 'createdate',
						align: 'center',
						width: '16%'
					},
					{
						title: '完成時間',
						dataIndex: 'auditfinish_date',
						align: 'center',
						width: '16%'
					},
					{
						title: '開戶方式',
						dataIndex: '',
						align: 'center',
						width: '9%',
						scopedSlots:{
							customRender:'khtype'
						}
					},
					
					{
						title: '審核狀態',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots:{
							customRender:'khaduit'
						}
					},
				],
				columnsData: [],
				khstatus: [{
					text: '全部',
					value: ''
				},{
					text: '完成開戶',
					value: '1'
				},
				{
					text: '開戶審批',
					value: '2'
				},
				{
					text: '取消開戶',
					value: '3'
				}
				],
				admintypeArr: [
					{
							text: '全部',
							value: ''
						},{
						text: '網上開戶',
						value: '0'
					},
					{
						text: '預約開戶',
						value: '1'
					}, {
						text: '支票開戶',
						value: '2'
					},
					// {
					// 	text: '取消開戶',
					// 	value: '-1'
					// }
				],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					khtype:'',
					enddate: '',
					perPage: 6, //每頁條目數
					"inviterid": "",
					khcancelnum: '',
					khfinishnum: '',
					khunfinishnum: '',
					khstatus:'',
					area:''
				}
			}
		},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) *  _this.params.perPage;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum *  _this.params.perPage;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},

		},
		mounted() {
			this.getdate()
		},
		methods: {
			getfn(){
				this.fanhand()
				return this.params
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getdate();
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begindate = this.params.begindate ? App.oDate.secsTime3(this.params.begindate
						._d) : '',
					//認購截止日期
					this.params.enddate = this.params.enddate ? App.oDate.secsTime3(this.params.enddate
						._d) : ''
			},
			getdate() {
				this.params.inviterid = this.itemobj.inviterid
				
				if(this.params.begindate) this.params.begindate = this.params.begindate._d ? App.oDate.secsTime3(this.params.begindate._d) : this
					.params.begindate
				if(this.params.enddate) this.params.enddate = this.params.enddate._d ? App.oDate.secsTime3(this.params.enddate._d) : this.params
					.enddate
				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getSubmit,
					data: this.params
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.columnsData = res.data.submittedKhList
						this.params.missionnum = res.data.missionnum
						this.params.pageNum = res.data.pageNum
						this.params.total = res.data.total
						this.params.perPage = res.data.perPage
						this.params.khcancelnum = res.data.khcancelnum
						this.params.khfinishnum = res.data.khfinishnum
						this.params.khunfinishnum = res.data.khunfinishnum
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			disabledDate(current) {
				if (this.params.enddate) {
					return current && current > this.params.enddate;
				} else {
					return false
				}
			},
			disabledDates(current) {
				if (this.params.begindate) {
					return current && current < this.params.begindate;
				} else {
					return false
				}
			},
			clearEvent() {
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					khtype:'',
					enddate: '',
					perPage: 6, //每頁條目數
					"inviterid": "",
					khcancelnum: '',
					khfinishnum: '',
					khunfinishnum: '',
					khstatus:'',
					area:''
				}
				this.$refs['seachope'].handleSearch('')
				this.getdate()
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
		}
	}
</script>
<style scoped>
	.look_tuijian img{
		margin-top: -.1rem;
	}
</style>
<style lang="scss">
	#yitijiao {
		.ant-col-6{
			line-height: 1.7rem;
			display: flex;
			    justify-content: start;
			    align-items: center;
		}
		.ant-col-6>div:first-child{
			margin-right: 10px;
		}
		.ant-table-thead > tr > th, .ant-table-tbody > tr > td{
			// padding: 16px 9px;
		}
		.wimg {
			width: 1rem;
		}

		.fath_yiti {
			div {
				display: inline-block;
				margin: 0 .2rem;
			}
		}

		.ant-table-thead>tr:first-child>th:first-child {
			font-size: .8rem;
		}

		.ant-table-thead>tr>th {
			font-size: .8rem;
		}

		.ant-col {
			margin: 0.5rem 0 0.4rem !important;
		}

		.ant-pagination-prev,
		.ant-pagination-next,
		.ant-pagination-jump-prev,
		.ant-pagination-jump-next {
			min-width: 28px;
			height: 1.5rem;
			min-height: 28px;
			line-height: 1.5rem;
		}

		.ant-pagination-item {
			min-width: 28px;
			height: 1.5rem;
			min-height: 28px;
			line-height: 1.5rem;
		}

		.bottomMain {
			background-color: #fff;
			display: flex;
			align-items: center;
			padding: 1.6rem 1.04rem;
		}

		.wrplf {
			display: flex;
			justify-content: space-between;
		}

		.topBtn {
			padding: .8rem 1.04rem;
			border-radius: 2.6rem;
			/* margin-left:0.8rem; */
			color: #fff;
			display: inline-flex;
			align-items: center;
		}

		.ant-table-tbody {}
	}

	#ediotable tr td:nth-last-child(1),
	#ediotable tr th:nth-last-child(1) {
		border-right: 1px solid #e8e8e8 !important;
	}

	#ediotable .ant-table-bordered .ant-table-thead>tr>th,
	#ediotable .ant-table-bordered .ant-table-tbody>tr>td {
		border-right: unset;
	}

	#yitijiao .paginationView {
		padding: 0.5rem 0;
		display: flex;
		align-items: center;
		width: 100%;
		color: #666666;
		/* height:calc(100vh - 142px); */
	}

	#yitijiao .ant-pagination-item {
		background-color: #fff;
		border-color: #bfbfbf;
		color: #999999;
		margin-right: 1rem;
	}

	#yitijiao .ant-pagination-prev {
		margin-right: 1rem;
	}

	#yitijiao .ant-pagination-item a {
		color: inherit;
	}

	#yitijiao .ant-pagination-item-active {
		background-color: #f3f3f3;
		border-color: #d8d8d8;
		color: #000;
	}

	#yitijiao .ant-pagination-prev .ant-pagination-item-link,
	#yitijiao .ant-pagination-next .ant-pagination-item-link {
		background-color: #fff;
		color: #666666;
		border: 1px solid #bfbfbf;
	}

	#yitijiao .ant-pagination-disabled a,
	#yitijiao .ant-pagination-disabled:hover a,
	#yitijiao .ant-pagination-disabled:focus a,
	#yitijiao .ant-pagination-disabled .ant-pagination-item-link,
	#yitijiao .ant-pagination-disabled:hover .ant-pagination-item-link,
	#yitijiao .ant-pagination-disabled:focus .ant-pagination-item-link {
		background-color: #d8d8d8 !important;
		color: #fff !important;
	}

	#yitijiao .pageTzView {
		display: flex;
		align-items: center;
		margin-left: 0.7rem;
	}
	
	#yitijiao tr td{
		font-size: .7rem;
	}
	
	#yitijiao .pageTzView input {
		width: 2.6rem;
		height: 1.5rem;
		border: 1px solid #bfbfbf;
		outline: unset;
		margin-right: 0.25rem;
		border-radius: 4px;
		text-align: center;
	}

	#yitijiao .pageTzView span {
		background-color: #d8d8d8;
		border-radius: 4px;
		height: 1.5rem;
		color: #666666;
		padding: 0 0.625rem;
		line-height: 1.5rem;
	}
</style>
